import { variables, pick } from '@splunk/themes';

const commonUIBackgroundColor = variables.backgroundColorNavigation;

const commonUIBorderColor = variables.borderColor;

export const monacoColors = {
    background: {
        light: '#FFFFFE',
        dark: '#222222',
    },
    popup: {
        light: '#DDDDDD',
        dark: '#000000',
    },
};

export const customThemeVariables = {
    resizeHandleColor: pick({
        light: '#0264D7', // variable.interactiveColorPrimary in SUI4 prisma, revisit when more suitable variable is available
        dark: '#3993FF',
    }),
    invalidDropTargetBackgroundColor: '#8A393B',
    validDropTargetBackgroundColor: pick({
        light: '#80EC9F',
        dark: '#117E32',
    }),
    invalidDropTargetBorderColor: pick({
        enterprise: '#FE3A3A',
        prisma: variables.accentColorNegative,
    }),
    validDropTargetBorderColor: pick({
        light: '#07BA39',
        dark: '#08E045',
    }),
    selectedInputBackgroundColor: pick({
        enterprise: {
            light: variables.gray92,
            dark: variables.gray30,
        },
        prisma: variables.backgroundColorPopup,
    }),
    selectedInputBorderColor: pick({
        enterprise: {
            light: variables.borderColor,
            dark: variables.gray45,
        },
        prisma: variables.contentColorDisabled,
    }),
    vizPanelBackgroundColor: pick({
        enterprise: {
            light: variables.white,
            dark: variables.black,
        },
        prisma: variables.backgroundColorSection,
    }),
    toolbarBackgroundColor: commonUIBackgroundColor,
    toolbarBorderColor: commonUIBorderColor,
    sidebarPanelBackgroundColor: pick({
        enterprise: {
            light: variables.white,
            dark: variables.black,
        },
        prisma: variables.backgroundColorSidebar,
    }),
    sidebarPanelBorderColor: commonUIBorderColor,
    monacoBackgroundColor: pick(monacoColors.background),
    monacoBorder: '1px solid rgba(0, 0, 0, 0.15)',
};
